import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-337906c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "content view",
  id: "teleported"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_course_track = _resolveComponent("course-track")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.courseTracks.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.courseTracks, (courseTrack, index) => {
          return (_openBlock(), _createBlock(_component_course_track, {
            key: 'courseTrack' + index,
            courseTrack: courseTrack,
            class: "course-track"
          }, null, 8, ["courseTrack"]))
        }), 128))
      : _createCommentVNode("", true)
  ]))
}